import { LocationState } from "@/vuex/modules/location/location.types";

export const state: LocationState = {
  locations: [],
  defaultLocations: [],
  loading: false
};
